import React, { Fragment } from 'react';
import HandoffImage from '../../containers/handoff/HandoffImage';
import HandoffText from '../../containers/handoff/HandoffText';
import Header from '../../containers/handoff/Header';
import SelectedElementAssets from '../../containers/handoff/sidebar/SelectedElementAssets';
import HandoffGroup from './HandoffGroup';
import HandoffShape from './HandoffShape';
var specs = {
    raster: React.createElement(HandoffImage, null),
    text: React.createElement(HandoffText, null),
    shape: React.createElement(HandoffShape, null),
    path: React.createElement(HandoffShape, null),
    group: React.createElement(HandoffGroup, null),
    mask: React.createElement(HandoffGroup, null),
    compoundpath: React.createElement(HandoffShape, null),
    slice: React.createElement(HandoffImage, null),
};
export default function ElementHandoff(_a) {
    var selectedElementType = _a.selectedElementType;
    return (React.createElement(Fragment, null,
        React.createElement(Header, null),
        React.createElement(SelectedElementAssets, null),
        specs[selectedElementType]));
}
